/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([], function( ) {

	class SmartTitleAPI {

		/**
		 * @function SmartTitleAPI#upgrade
		 * @description upgrade title spec
		 * @return {}
		 */
		upgradeIfNeeded(){}

		/**
		 * @function SmartTitleAPI#prepare
		 * @description setup smart title for widget
		 * @return {}
		 */
		prepare(){}

		/**
		 * @function SmartTitleAPI#enableSmartTitle
		 * @description enables smart title for widget
		 * @return {}
		 */
		enableAndSetSmartTitle(){}

		/**
		 * @function SmartTitleAPI#disableSmartTitle
		 * @description disables smart title for widgets, reverts to editable title
		 * @return {}
		 */
		disableSmartTitle(){}

		/**
		 * @function SmartTitleAPI#getTitleState
		 * @description gets title state
		 * @return { }
		 */
		getTitleState(){}


		/**
		 * @function SmartTitleAPI#shouldUseGeneratedTitle
		 * @description gets title state
		 * @return { }
		 */
		shouldUseGeneratedTitle(){}


		/**
		 * @function SmartTitleAPI#shouldSetTitle
		 * @description checks is title is same as before
		 * @return { }
		 */
		shouldSetTitle(){}

		/**
		 * @function SmartTitleAPI#getTitleHtmlWithPreviousFormat
		 * @description returns title html using previous title format
		 * @return { }
		 */
		getTitleHtmlWithPreviousFormat(){}

	}

	return SmartTitleAPI;

});
